import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { normalize } from 'normalizr';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router';

import ErrorHandler from '~/components/ErrorHandler';
import Loading from '~/components/Loading';

import { ADD_ENTITIES } from '~/modules/entity';
import {
  fetchImage,
  galleryImageSchema,
  getImageById,
} from '~/modules/gallery';

import config from '~/config';
import { withRouter } from '~/hooks';

import PasswordPrompt from '../PasswordPrompt';
import Edit from './Edit';
import View from './View';

function GalleryImage(props) {
  const {
    params: { imageId },
  } = props;
  const [errorCode, setError] = useState(null);
  const [isProtected, setProtected] = useState(false);
  const [password, setPassword] = useState(null);
  const dispatch = useDispatch();
  const image = useSelector((state) =>
    getImageById(state, parseInt(imageId || '', 10))
  );

  const { isLoading, data } = useQuery({
    initialData: image,
    refetchInterval: 0,
    queryKey: ['galleryImage', imageId, password],
    queryFn: async () => {
      const url = `${config.api}/gallery/${imageId}${password ? `?password=${password}` : ''}`;
      const res = await axios.get(url).catch((error) => {
        console.error('Error fetching image:', error);
        if (error.status === 403) {
          setProtected(true);
          setPassword(null);

          return {
            data: {
              status: 'error',
              code: 'FORBIDDEN',
            },
            ok: false,
            status: 403,
          };
        }

        return {
          data: {
            status: 'error',
            code: 'ERROR',
          },
          ok: false,
        };
      });

      return { ...res.data, ok: res.status === 200 };
    },
    enabled: !!imageId,
    retry: false,
  });

  useEffect(() => {
    if (data) {
      const normalized = normalize(data, galleryImageSchema);
      console.log('Normalized data:', normalized);
      dispatch({
        type: ADD_ENTITIES,
        payload: normalized.entities,
      });
    }
  }, [data, dispatch]);

  // If protected and missing correct password, show password prompt
  if (isProtected && !password) {
    return (
      <PasswordPrompt
        handleSubmit={(values) => {
          setPassword(values.password);
          setError(null);
        }}
      />
    );
  }

  return (
    <Fragment>
      <ErrorHandler statusCode={errorCode} />
      {isLoading || !image || (image && image.status === 'error') ? (
        <Loading message="Loading image..." />
      ) : (
        <Routes>
          <Route path="">
            <Route index element={<View />} />
            <Route path="edit" element={<Edit />} />
          </Route>
        </Routes>
      )}
    </Fragment>
  );
}

export const GalleryImageHydrate = (dispatch, params) => {
  return dispatch(fetchImage(params.imageId));
};

export default withRouter(GalleryImage);
